var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<tr data-user-id=\""
    + alias3(alias2(alias1(depth0, "user_id", {"start":{"line":2,"column":20},"end":{"line":2,"column":27}} ), depth0))
    + "\" data-user-name=\""
    + alias3(alias2(alias1(depth0, "user_name", {"start":{"line":2,"column":49},"end":{"line":2,"column":58}} ), depth0))
    + "\" data-date-muted=\""
    + alias3(alias2(alias1(depth0, "date_muted_str", {"start":{"line":2,"column":81},"end":{"line":2,"column":95}} ), depth0))
    + "\">\n    <td>"
    + alias3(alias2(alias1(depth0, "user_name", {"start":{"line":3,"column":10},"end":{"line":3,"column":19}} ), depth0))
    + "</td>\n    <td>"
    + alias3(alias2(alias1(depth0, "date_muted_str", {"start":{"line":4,"column":10},"end":{"line":4,"column":24}} ), depth0))
    + "</td>\n    <td class=\"actions\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"can_unmute"),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
    + "    </td>\n</tr>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.invokePartial(require("./components/action_button.hbs"),undefined,{"name":"./components/action_button","hash":{"custom_classes":"settings-unmute-user","intent":"danger","attention":"quiet","label":lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Unmute",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":8,"column":16},"end":{"line":8,"column":28}}})},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"muted_user"),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":16,"column":9}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});